export default {
  title: "Timeline",
  description: "Plan your wedding day schedule",
  subtitle: "Organize the flow of your wedding day",
  addEvent: "Add Event",
  editEvent: "Edit Event",
  deleteEvent: "Delete Event",
  noEvents: "No events found",
  addFirstEvent: "Add your first event",
  eventDeleted: "Event successfully deleted",
  eventCreated: "Event successfully created",
  eventUpdated: "Event successfully updated",
  categories: {
    ceremony: "Ceremony",
    reception: "Reception",
    photos: "Photos",
    transport: "Transport",
    preparation: "Preparation",
    other: "Other",
    vendor: "Vendor",
    task: "Task",
    reminder: "Reminder",
    custom: "Custom",
    photo: "Photo",
    party: "Party",
    entertainment: "Entertainment",
    meal: "Meal",
    transportation: "Transport",
    select: "Select a category",
    religious_venue: "Place of worship",
    city_hall: "City hall",
    none: "None"
  },
  form: {
    title: "Title",
    description: "Description",
    date: "Date",
    time: "Time",
    location: "Location",
    duration: "Duration",
    category: "Category",
    notes: "Notes",
    titlePlaceholder: "Event title",
    descriptionPlaceholder: "Event description",
    durationLabel: "Duration (minutes)",
    participants: "Participants",
    reminders: "Reminders",
    startTime: "Start Time",
    endTime: "End Time",
    locationPlaceholder: "Event location",
    categoryPlaceholder: "Event category",
    notesPlaceholder: "Additional notes",
    name: "Last name",
    submit: "Save",
    cancel: "Cancel"
  },
  status: {
    scheduled: "Scheduled",
    in_progress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    delayed: "Delayed",
    confirmed: "Confirmed"
  },
  view: {
    day: "Day",
    week: "Week",
    month: "Month",
    today: "Today",
    daysLeft: "{{count}} days remaining",
    upcoming: "Upcoming"
  },
  duration: "Duration",
  participants: "Participants",
  reminders: "Reminders",
  empty: {
    title: "No event",
    description: "Start planning your day by adding events."
  },
  examples: {
    preparation: {
      title: "Preparation",
      description: "Styling, Make-up and Dressing of the bride and groom"
    },
    ceremony: {
      title: "Ceremony",
      description: "Wedding ceremony"
    },
    cocktail: {
      title: "Cocktail",
      description: "Drinks and appetizers for guests after the ceremony"
    },
    lunch: {
      title: "Lunch / Dinner",
      description: "Wedding meal"
    },
    speeches: {
      title: "Speeches",
      description: "Speeches from witnesses and family"
    },
    cake: {
      title: "Cake",
      description: "Cake cutting and champagne"
    },
    party: {
      title: "Party",
      description: "First dance and dance party"
    },
    dinner: {
      title: "Dinner",
      description: "Main meal for all guests"
    },
    firstDance: {
      title: "First Dance",
      description: "First dance of the newlyweds"
    },
    cakeCutting: {
      title: "Cake Cutting",
      description: "Traditional wedding cake cutting"
    },
    guestsArrival: {
      title: "Guests Arrival",
      description: "Guests start arriving at the venue"
    },
    dancing: {
      title: "Dancing",
      description: "The dance floor is open"
    }
  },
  sharing: {
    recipientEmail: "Recipient Email",
    emailPlaceholder: "example@email.com",
    recipientName: "Recipient Name",
    namePlaceholder: "Name",
    message: "Message",
    messagePlaceholder: "Your message...",
    send: "Send",
    cancel: "Cancel",
    title: "Share timeline"
  },
  actions: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    update: "Update",
    addEvent: "Add an event",
    share: "Share",
    useExample: "Use a template",
    addExamples: "Add examples",
    addingExamples: "Adding examples..."
  },
  messages: {
    eventAdded: "Event added successfully",
    eventUpdated: "Event updated successfully",
    eventDeleted: "Event deleted successfully",
    error: "An error occurred",
    createSuccess: "Event added successfully",
    updateSuccess: "Event updated successfully",
    deleteSuccess: "Event deleted successfully",
    deleteConfirm: "Are you sure you want to delete this event?"
  },
  confirmDeleteEvent: "Are you sure you want to delete this event?",
  totalEvents: "{{count}} events",
  filterByCategory: "Filter by category",
  allCategories: "All categories",
  emptyState: {
    title: "Your timeline is empty",
    description: "Plan the events of your wedding day",
    action: "Add event"
  },
  timespan: "{{start}} - {{end}}",
  errors: {
    loadEvents: "Error loading events",
    createEvent: "Error creating event",
    updateEvent: "Error updating event",
    deleteEvent: "Error deleting event",
    noWeddingFound: "No wedding found",
    createWeddingFirst: "Please create a wedding first",
    addEvent: "Error adding event",
    addExampleEvents: "Error adding example events"
  },
  titlePlaceholder: "Event name",
  descriptionPlaceholder: "Event description",
  durationLabel: "Duration",
  timelineWidget: {
    title: "Timeline",
    subtitle: "Upcoming events",
    empty: "No upcoming events"
  },
  filters: {
    category: "Category",
    date: "Date",
    search: "Search an event",
    clear: "Clear filters",
    apply: "Apply",
    previous: "Previous",
    next: "Next"
  },
  minutesAbbr: "min",
  delete: {
    title: "Delete event",
    confirmation: "Are you sure you want to delete this event? This action is irreversible."
  },
  aria: {
    addEvent: "Add an event",
    edit: "Edit event",
    delete: "Delete event"
  },
  modal: {
    title: "Event",
    edit: "Edit event",
    delete: "Delete event",
    confirmDelete: "Are you sure you want to delete this event?"
  }
};
